import {FIELD_TYPES} from 'Core/Constant';

export const ICON_CLASSES = {};

ICON_CLASSES[FIELD_TYPES.Time] = 'fa-solid fa-clock';
ICON_CLASSES[FIELD_TYPES.TimeSpan] = 'fa-solid fa-clock';
ICON_CLASSES[FIELD_TYPES.Date] = 'fa-solid fa-calendar-days';
ICON_CLASSES[FIELD_TYPES.DateTime] = 'fa-solid fa-calendar-days';